// extracted by mini-css-extract-plugin
module.exports = {"horizontal":"_1VxB6","content":"mhzHr","vertical":"_1Rd2C","title":"qPWC1"};